export default __webpack_public_path__ + "assets/92f151bd3e813f1e3a8cc5d7c01831ca.svg";